'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _handleEmpty = require('../helpers/handleEmpty');

var _handleEmpty2 = _interopRequireDefault(_handleEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Row = function (_PureComponent) {
  _inherits(Row, _PureComponent);

  function Row() {
    _classCallCheck(this, Row);

    return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
  }

  _createClass(Row, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rowData = _props.rowData,
          columns = _props.columns,
          setRowClass = _props.setRowClass,
          specialRow = _props.specialRow;


      return specialRow(rowData) || _react2.default.createElement(
        'tr',
        {
          className: (0, _classnames2.default)('ui-table__row', setRowClass && setRowClass(rowData))
        },
        columns.map(function (_ref) {
          var className = _ref.className,
              key = _ref.key,
              cell = _ref.cell;
          return _react2.default.createElement(
            'td',
            {
              className: (0, _classnames2.default)('ui-table__cell', className),
              key: key
            },
            cell ? cell(rowData) : (0, _handleEmpty2.default)(rowData[key])
          );
        })
      );
    }
  }]);

  return Row;
}(_react.PureComponent);

Row.defaultProps = {
  specialRow: function specialRow() {
    return false;
  }
};

Row.propTypes = {
  rowData: _propTypes2.default.shape({}).isRequired,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string,
    cell: _propTypes2.default.func,
    className: _propTypes2.default.string
  })).isRequired,
  setRowClass: _propTypes2.default.func,
  specialRow: _propTypes2.default.func
};

exports.default = Row;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/components/Row.js
// module id = 587
// module chunks = 0